((Drupal, drupalSettings) => {
  Drupal.behaviors.mapBehavior = {
    attach: function (context) {
      const mapElement = document.querySelector("#openstreetmaps_centre");

      if (!mapElement) {
        console.error(
          'Élément avec l\'ID "openstreetmaps_centre" introuvable.'
        );
        return;
      }

      // Récupérer les données de l'attribut data
      const lat = parseFloat(mapElement.dataset.lat);
      const lng = parseFloat(mapElement.dataset.lng);
      const adresse = mapElement.dataset.adresse || "Adresse non disponible";
      const lieu = mapElement.dataset.lieu || "Lieu non disponible";
      const cp = mapElement.dataset.cp || "";
      const telephone =
        mapElement.dataset.telephone || "Téléphone non disponible";
      const email = mapElement.dataset.email || "Email non disponible";
      const horaire = mapElement.dataset.horaire || "Horaires non disponibles";
      const typeId = mapElement.dataset.typeId; // Récupérer le type ID

      // Vérification des coordonnées
      if (!lat || !lng) {
        console.error("Coordonnées invalides ou manquantes :", { lat, lng });
        return;
      }

      // Définir l'icône et la couleur SVG en fonction de typeId
      const iconUrl =
        typeId === "27"
          ? "/themes/custom/expansion/assets/dist/images/orange.png"
          : typeId === "28"
          ? "/themes/custom/expansion/assets/dist/images/green.png"
          : "/themes/custom/expansion/assets/dist/images/default.png";

      const svgColor =
        typeId === "27" ? "#E16020" : typeId === "28" ? "#009E99" : "#000";

      // Appliquer la variable CSS pour la couleur
      document.documentElement.style.setProperty("--color-type", svgColor);

      // Initialiser la carte
      const map = L.map(mapElement, {
        center: [lat, lng],
        zoom: 10,
        scrollWheelZoom: false,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      // Définir une icône personnalisée
      const customIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [26, 36],
        iconAnchor: [13, 36],
        popupAnchor: [0, -36],
      });

      // Ajouter le marqueur principal
      const marker = L.marker([lat, lng], { icon: customIcon });

      // Créer le contenu de la popup avec le SVG
      const popupContent = `
        <div style="padding: 10px; font-family: Arial, sans-serif; font-size: 14px;">
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="25" viewBox="0 0 18 25" fill="none">
              <path d="M9 24.5C9 24.5 18 15.971 18 9.5C18 7.11305 17.0518 4.82387 15.364 3.13604C13.6761 1.44821 11.3869 0.5 9 0.5C6.61305 0.5 4.32387 1.44821 2.63604 3.13604C0.948211 4.82387 3.55683e-08 7.11305 0 9.5C0 15.971 9 24.5 9 24.5ZM9 14C7.80653 14 6.66193 13.5259 5.81802 12.682C4.97411 11.8381 4.5 10.6935 4.5 9.5C4.5 8.30653 4.97411 7.16193 5.81802 6.31802C6.66193 5.47411 7.80653 5 9 5C10.1935 5 11.3381 5.47411 12.182 6.31802C13.0259 7.16193 13.5 8.30653 13.5 9.5C13.5 10.6935 13.0259 11.8381 12.182 12.682C11.3381 13.5259 10.1935 14 9 14Z" fill="${svgColor}"/>
            </svg>
            ${lieu}
          </h3>
          <p><strong>Adresse :</strong> ${adresse}, ${cp}</p>
          <p><strong>Horaires :</strong><br>${horaire}</p>
        </div>
      `;

      marker.bindPopup(popupContent);

      // Ajouter le marqueur à la carte
      marker.addTo(map);

      // Centrer la vue sur le marqueur
      map.setView([lat, lng], 10);
    },
  };
})(Drupal, drupalSettings);

// Gestion des boutons StreetView et Carte
const btnStreetview = document.getElementById("btn-streetview");
const btnCarte = document.getElementById("btn-carte");
const mapElement = document.getElementById("openstreetmaps_centre");
const streetviewIframe = document.getElementById("iframe-streetview");
const buttons = document.querySelectorAll(".btn-toggle");

const setActiveButton = (activeButton) => {
  buttons.forEach((button) => button.classList.remove("active"));
  activeButton.classList.add("active");
};

// Afficher la carte par défaut
mapElement.style.display = "block";
streetviewIframe.style.display = "none";

btnStreetview.addEventListener("click", () => {
  mapElement.style.display = "none";
  streetviewIframe.style.display = "block";
  setActiveButton(btnStreetview);
});

btnCarte.addEventListener("click", () => {
  mapElement.style.display = "block";
  streetviewIframe.style.display = "none";
  setActiveButton(btnCarte);
});
